// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var element = "NavItem-module--element--dSwLj";
export var horizontal = "NavItem-module--horizontal--a78Hc";
export var active = "NavItem-module--active--Vvbl8";
export var vertical = "NavItem-module--vertical--q5DTd";
export var withSeparator = "NavItem-module--withSeparator--6AQ3H";
export var mainNav = "NavItem-module--mainNav--FFToJ";
export var isWhite = "NavItem-module--isWhite--rNc0l";
export var activeNav = "NavItem-module--activeNav--WsdCz";